import "./AirConditionerTechnician.module.css";
import Header from "@/reusable_sections/Header";
import TecnicoEnAiresAcondicionadosResumen from "./sections/TecnicoEnAiresAcondicionadosResumen";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import InvitacionAInscribirse from "./sections/InvitacionAInscribirse";
import Footer from "@/reusable_sections/Footer";
export default function AirConditionerTechnicianPage() {
  return <div>
      <Header />
      <TecnicoEnAiresAcondicionadosResumen />
      <DetallesDelCurso />
      <InvitacionAInscribirse />
      <Footer />
    </div>;
}